import reducers from './reducers';

import * as affiliateOperations from './operations';
import * as affiliateSelectors from './selectors';
import * as affiliateTypes from './types';

export { affiliateOperations, affiliateSelectors, affiliateTypes };

export default reducers;
